import * as React from 'react';
import { useContext } from 'react';
import { ActionPlanView, permissionGroupHelper } from '../../../amorg-common';
import { Button } from '../../../designSystem/button/Button';
import { LinkButton } from '../../../designSystem/button/LinkButton';
import { Card } from '../../../designSystem/Card';
import { AnimatedCollapsibleContent } from '../../../designSystem/collapsible/AnimatedCollapsibleContent';
import { Flex } from '../../../designSystem/compositeComponents/FlexHelpers';
import { Toggletip } from '../../../designSystem/Toggletip';
import { H2 } from '../../../designSystem/typography/Heading';
import { ArticleVersionFields } from '../../_components/articles/ArticleVersionFields';
import { ProtectedPageContext } from '../../_contexts/ProtectedPageContext';
import { ActionPlanSurveySegmentPanel } from './ActionPlanSurveySegmentPanel';
import { PageSection } from '../../../designSystem/PageSection';
import { InfoChip } from '../../../designSystem/Chip';

type ActionPlanContextPanelProps = {
    actionPlan: ActionPlanView,
    onUpdated: () => void
};
export function ActionPlanContextPanel (props: ActionPlanContextPanelProps): JSX.Element
{

    async function handleUpdated()
    {
        props.onUpdated();
    }

    const activeUser = useContext(ProtectedPageContext).user;
    const hasAccess = activeUser && permissionGroupHelper.hasMinimumPermissionGroup(activeUser.permissionGroupId, 'member');

    return (
        <>
            {props.actionPlan.type === 'WPA' && hasAccess &&
                props.actionPlan.surveyData.surveyAnswerCount > 0 && props.actionPlan.surveyData.segmentReport.length > 0 &&

                <PageSection headerStyleVariant='card' contentStyleVariant='card'
                    header={{
                        title: "Valgte rapportsegmenter", 
                        tooltip: "Når du vælger segmenter for handleplanen, kan du oprette emner automatisk baseret på data fra spørgeskemaet",
                        tooltipHorizontalAlignment: 'left',
                        defaultCollapsed:false
                    }}>

                    <ActionPlanSurveySegmentPanel
                        activityId={props.actionPlan.activityId}
                        actionPlan={props.actionPlan}
                        onActionPlanUpdated={handleUpdated} />

                </PageSection>
            }

            {props.actionPlan.type === 'Article' &&
                <CollapsibleWrapper title="Lovkravet">
                    {props.actionPlan.articleData.isDeleted &&
                        <div>
                            <InfoChip variant='error'>Lovkravet er udgået</InfoChip>
                        </div>
                    }
                    <ArticleVersionFields {...props.actionPlan.articleData} 
                        articleId={props.actionPlan.customData.articleId} 
                        importance={props.actionPlan.articleData.importance}
                        selectedCategoryTag={props.actionPlan.articleData.categoryTag}
                        disableEdit />
                    <Flex justifyContent='flex-end' style={{ marginTop: '10px' }}>
                        {!props.actionPlan.articleData.isDeleted &&
                            <LinkButton variant='outlined' icon="arrows_chevron_chevronForward" text="Gå til lovkravet"
                                href={`/articles/${props.actionPlan.customData.articleId}`} />
                        }
                    </Flex>
                </CollapsibleWrapper>
            }
        </>
    );
}

function CollapsibleWrapper(props:{title:string, tooltip?:React.ReactNode, children: React.ReactNode}): JSX.Element
{
    const [isOpen, setIsOpen] = React.useState<boolean>(true);

    return (
        <Flex flexDirection="column" gap={16} style={{ marginLeft: '40px' }}>
            <Flex justifyContent='stretch'>
                <Flex gap={4} alignItems='center' grow='1'>
                    <H2>{props.title}</H2>
                    {props.tooltip &&
                        <Toggletip>
                            {props.tooltip}
                        </Toggletip>
                    }
                </Flex>
                <Button variant='text' icon={isOpen ? 'arrows_chevron_chevronUp' : 'arrows_chevron_chevronDown'} 
                    onClick={() => setIsOpen(!isOpen)} />
            </Flex>
            
            <AnimatedCollapsibleContent open={isOpen}>
                <Card variant="outlined">
                    {props.children}
                </Card>
            </AnimatedCollapsibleContent>
        </Flex>
    );
}